







import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class Status extends Vue {
    @Prop({ type: String, required: false }) public text?: string;
    @Prop({ type: Boolean, required: false, default: false }) public isLoading?: boolean;
}
